import React from "react";

const UeDataBulletL = (props) => {
    return (
        <span
            className={"mr-1 ml-1"}
            style={{
                fontSize: "30px",
                lineHeight: "7px",
                verticalAlign: "middle",
                color: props.color ? props.color : "var(--theme-primary)",
            }}
        >
            &bull;
        </span>
    );
};

export default UeDataBulletL;
